import type { FeedingInfo } from '../../types/careExpanded';

interface FeedingSectionProps {
  feeding: FeedingInfo;
}

export function FeedingSection({ feeding }: FeedingSectionProps) {
  return (
    <div className="space-y-3">
      {/* Product and frequency */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Fertilizer Type
          </dt>
          <dd className="mt-1 text-sm text-editorial-black font-medium">{feeding.product}</dd>
        </div>
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Schedule
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{feeding.frequency}</dd>
        </div>
      </div>

      {/* Dilution info */}
      {feeding.dilution && (
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-500/10 text-green-600">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm font-medium">{feeding.dilution}</span>
        </div>
      )}

      {/* Seasonal notes */}
      {feeding.seasonalNotes && (
        <div className="p-3 rounded-lg bg-primary/5 border border-primary/10">
          <dt className="text-xs font-medium uppercase tracking-wide text-primary">
            Seasonal Schedule
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{feeding.seasonalNotes}</dd>
        </div>
      )}
    </div>
  );
}
